import React, {FC, useState} from 'react';
import {PaymentElement, useStripe, useElements} from '@stripe/react-stripe-js';
import {Spin, Button} from 'antd';

interface DepositFormProps {
    onSuccess: () => void;
    onError: () => void;
}

const DepositForm: FC<DepositFormProps> = ({onSuccess, onError}) => {
    const stripe = useStripe();
    const elements = useElements();
    const [complete, setComplete] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!stripe || !elements || !complete) return;

        setProcessing(true);
        const {error, paymentIntent} = await stripe.confirmPayment({elements, redirect: 'if_required'});
        if (error) {
            setErrorMsg(error.message || 'Payment failed');
            onError();
        } else if (paymentIntent?.status === 'succeeded') {
            onSuccess();
        } else {
            setErrorMsg('Payment status: ' + paymentIntent?.status);
            onError();
        }
        setProcessing(false);
    };

    return (
        <Spin spinning={processing} tip="Processing payment…">
            <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column'}}>
                <PaymentElement
                    onChange={(e: any) => {
                        setComplete(e.complete);
                        setErrorMsg(e.error?.message || '');
                    }}
                />
                {errorMsg && <div style={{color: 'red', margin: '8px 0'}}>{errorMsg}</div>}
                <div style={{textAlign: 'right', marginTop: 16}}>
                    <Button htmlType="submit" type="primary" disabled={!complete || processing}>Pay</Button>
                </div>
            </form>
        </Spin>
    );
};

export default DepositForm;